var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.7502V7.01222M10 13.5208V13.5537M14.7249 16.6668H5.27506C3.98425 16.6668 2.89494 15.8137 2.55221 14.6466C2.40591 14.1484 2.58567 13.6294 2.86063 13.1876L7.58557 4.66768C8.69258 2.88877 11.3074 2.88877 12.4144 4.66769L17.1394 13.1876C17.4143 13.6294 17.5941 14.1484 17.4478 14.6466C17.1051 15.8137 16.0157 16.6668 14.7249 16.6668Z",
    stroke: "#FF2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.fa751331223b59acc7671bf43f2d096f.svg";
export { ForwardRef as ReactComponent };